import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../axios";
import Alert from "react-s-alert";
import Dropzone from 'react-dropzone'
import FormDropdown from './FormDropdown'
import DatePicker from 'react-datepicker'
import { status_aktif } from '../constants/general'
import { FOTO_WALI_HOST } from '../constants/siteConfig'
import moment from 'moment'

const jekel = [
    { key: "l", value: "Laki-laki" },
    { key: "p", value: "Perempuan" },
]

class FormModalWali extends Component {

    constructor(props) {
        super(props);

        this.state = {

            wali_id             : "",
			wali_nama           : "",
			wali_alamat         : "",
			wali_nohp           : "",
			wali_status         : "",
			wali_provinsi       : "",
			wali_kota           : "",
			wali_gender         : "",
			wali_tempat_lahir   : "",
			wali_tanggal_lahir  : moment().format('YYYY-MM-DD'),
			wali_tanggal_lahir_moment: moment(),
			wali_foto           : "",
			wali_foto_exist     : "",
			wali_siswa_id       : [],
			wali_siswa_nama     : [],
			wali_siswa_id_exist : [],
            wali_siswa_nama_exist: [],
            
            isLoadingBu : false
        }

        this.toggleModalWali = this.toggleModalWali.bind(this)
        this.handleSubmitWali = this.handleSubmitWali.bind(this)
		this.handleChangeDatepicker = this.handleChangeDatepicker.bind(this);
        this.handleChangeMod = this.handleChangeMod.bind(this)
		this.onDrop                 = this.onDrop.bind(this);
		this.handleDeleteFile       = this.handleDeleteFile.bind(this);
    }

    toggleModalWali() {
        this.props.toggleModalWali()
    }

    handleSubmitWali() {
        this.setState({ isLoadingBu: true })
        
        let formData = new FormData();

		formData.append('wali_id', this.state.wali_id)
		formData.append('user_id', this.state.user_id)
		formData.append('wali_nama', this.state.wali_nama)
		formData.append('wali_alamat', this.state.wali_alamat)
		formData.append('wali_nohp', this.state.wali_nohp)
		formData.append('wali_status', this.state.wali_status)
		formData.append('wali_provinsi', this.state.wali_provinsi)
		formData.append('wali_kota', this.state.wali_kota)
		formData.append('wali_gender', this.state.wali_gender)
		formData.append('wali_tempat_lahir', this.state.wali_tempat_lahir)
		formData.append('wali_tanggal_lahir', this.state.wali_tanggal_lahir)
		formData.append('wali_foto', this.state.wali_foto)
		formData.append('wali_username', this.state.wali_username)
		formData.append('wali_password', this.state.wali_password)
		formData.append('siswa_id', this.state.wali_siswa_id)

        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        axios.post("/wali/add", formData, config)
            .then(response => {
                const result = response.data;
                
                if (result.success){
                    Alert.success(result.message);
                    this.setState({wali_id:result.data, isLoadingBu: false,user_passw : '' }, ()=>{
                       window.location.reload();
                    });
                    this.toggleModalWali();
                }else{
                    Alert.success(result.message);
                    this.setState({ isLoadingBu: false,user_passw : '' }, ()=>{
                        window.location.reload();
                    });
                    this.toggleModalWali();
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({ isLoadingBu: false,user_passw : '' })
                Alert.error("Gagal terhubung ke server!")
            })
    }

	handleDeleteFile(stateName) {

		const newState = {}

		newState[stateName] = ""

		this.setState(newState)
	}
    
	onDrop(files, stateName) {

		const newState = {}

		newState[stateName] = files[0]

		this.setState(newState);
	}

	handleChangeDatepicker(momentObj, momentStateName, stateName) {

		const newState = {}

		newState[momentStateName]   = momentObj
		newState[stateName]         = momentObj.format('YYYY-MM-DD')

		this.setState(newState)
    }
    
    handleChangeMod(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }

    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.toggleModalWali} className="modal-primary custom-dialog">
                <ModalHeader toggle={this.toggleModalWali}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    
                    <div>                
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Nama Lengkap Wali</label>
                            <div className="col-md-10">
                                <input
                                    name="wali_nama"
                                    type="text"
                                    className="form-control"
                                    placeholder="Nama Lengkap"
                                    onChange={this.handleChangeMod}
                                    value={this.state.wali_nama} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">
                                No. HP <br />
                                <small className="text-muted">
                                    <table>
                                        <tr>
                                            <td style={{ verticalAlign: "top" }}><i className="fa fa-info-circle"></i>{" "}</td>
                                            <td>Digunakan sebagai username dan password default wali</td>
                                        </tr>
                                    </table>
                                </small>
                            </label>
                            <div className="col-md-10">
                                <input
                                    name="wali_nohp"
                                    type="number"
                                    className="form-control"
                                    placeholder="No. Handphone"
                                    onChange={this.handleChangeMod}
                                    value={this.state.wali_nohp} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Alamat</label>
                            <div className="col-md-10">
                                <textarea
                                    name="wali_alamat"
                                    className="form-control"
                                    placeholder="Alamat Lengkap"
                                    onChange={this.handleChangeMod}
                                    value={this.state.wali_alamat} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Kota</label>
                            <div className="col-md-10">
                                <input
                                    name="wali_kota"
                                    type="text"
                                    className="form-control"
                                    placeholder="Alamat Kota"
                                    onChange={this.handleChangeMod}
                                    value={this.state.wali_kota} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Provinsi</label>
                            <div className="col-md-10">
                                <input
                                    name="wali_provinsi"
                                    type="text"
                                    className="form-control"
                                    placeholder="Alamat Provinsi"
                                    onChange={this.handleChangeMod}
                                    value={this.state.wali_provinsi} />
                            </div>
                        </div>                
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Jenis Kelamin</label>
                            <div className="col-md-10">
                                <FormDropdown
                                    name="wali_gender"
                                    items={jekel}
                                    onChange={this.handleChangeMod}
                                    value={this.state.wali_gender} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Tempat Lahir</label>
                            <div className="col-md-10">
                                <input
                                    name="wali_tempat_lahir"
                                    type="text"
                                    className="form-control"
                                    placeholder="Tempat Lahir"
                                    onChange={this.handleChangeMod}
                                    value={this.state.wali_tempat_lahir} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Tanggal Lahir</label>
                            <div className="col-md-10">
                                <DatePicker
                                    selected={this.state.wali_tanggal_lahir_moment}
                                    onChange={(momentObj) => {
                                        this.handleChangeDatepicker(momentObj, "wali_tanggal_lahir_moment", "wali_tanggal_lahir")
                                    }}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">
                                Username
                            </label>
                            <div className="col-md-10">
                                <input 
                                    name="wali_username"
                                    type="text"
                                    className="form-control" 
                                    placeholder="Username untuk login" 
                                    onChange={this.handleChangeMod} 
                                    value={this.state.wali_username} />                                
                            </div>
                        </div> 
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">
                                Password
                            </label>
                            <div className="col-md-10">
                                <input 
                                    name="wali_password"
                                    type="password"
                                    className="form-control" 
                                    placeholder={this.props.mode === 'Edit' ? "Password (Biarkan kosong jika tidak ingin mengganti)" : "Password"}
                                    onChange={this.handleChangeMod} 
                                    value={this.state.wali_password} />                                
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-md-2 form-control-label">Status Aktif</label>
                            <div className="col-md-10">
                                <FormDropdown
                                    name="wali_status"
                                    items={status_aktif}
                                    onChange={this.handleChangeMod}
                                    value={this.state.wali_status} />
                            </div>
                        </div>                                
                        {
                            this.props.mode === "Edit" &&
                            (
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">Foto Wali</label>
                                    <div className="col-md-10">
                                        <img
                                            src={FOTO_WALI_HOST + this.state.wali_foto_exist}
                                            alt=""
                                            style={{ width: "300px" }} />
                                    </div>
                                </div>
                            )
                        } 
                        <div className="form-group row">
                            <label className="col-md-12 form-control-label">{this.props.mode === "Edit" && "Ganti"} File foto Wali</label>
                            <div className="col-md-12">
                                <Dropzone
                                    onDrop={(e) => this.onDrop(e, "wali_foto")}
                                    multiple={false}
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        border: "2px dashed #e9e9e9",
                                        padding: "20px 30px",
                                        color: "#888",
                                        cursor: "pointer",
                                        textAlign: "center",
                                        marginBottom: "15px"
                                    }}
                                >
                                    Klik atau drop file disini untuk mengupload file
                                </Dropzone>

                                {
                                    this.state.wali_foto !== "" &&
                                    <span>
                                        {this.state.wali_foto.name} {" "}
                                        <button
                                            title="Hapus"
                                            className="btn btn-sm btn-danger"
                                            onClick={() => this.handleDeleteFile("wali_foto")}
                                            type="button"
                                        >
                                            <i className="fa fa-remove"></i>
                                        </button>
                                    </span>
                                }
                            </div>
                        </div>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <button 
						type="button" 
						className="btn btn-md btn-primary"
						disabled={this.state.isButtonLoading && "disabled"}
						onClick={this.handleSubmitWali}>
                            
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
					</button>{' '}
                    <Button color="secondary" onClick={this.toggleModalWali}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

FormModalWali.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModalWali: PropTypes.func.isRequired
}

export default FormModalWali


// WEBPACK FOOTER //
// ./src/components/FormModalWali.js